var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStoreRustore = function SvgStoreRustore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D252D",
    fillRule: "evenodd",
    d: "M24.964 24.582v1.926c0 1.03-.982 1.786-1.995 1.536l-2.273-.563a.65.65 0 0 1-.435-.588l-.279-8.162c-.08-1.08-.89-1.94-1.734-2.193a.114.114 0 0 0-.127.046.095.095 0 0 0 .023.128c.208.16.783.683.783 1.585l-.002 8.741.002.005v1.926c0 1.03-.982 1.786-1.995 1.535l-6.415-1.588A1.984 1.984 0 0 1 9 26.996V16.31c0-1.03.982-1.786 1.995-1.535l4.042 1v-1.926c0-1.03.982-1.786 1.995-1.535l4.041 1v-1.926c0-1.03.982-1.786 1.995-1.535l6.415 1.59A1.984 1.984 0 0 1 31 13.36v10.688c0 1.03-.982 1.786-1.995 1.535l-2.23-.552a.64.64 0 0 1-.475-.598l-.28-8.162c-.08-1.08-.889-1.94-1.734-2.192a.11.11 0 0 0-.126.045.095.095 0 0 0 .022.129c.209.16.783.683.783 1.585z",
    clipRule: "evenodd"
  })));
};
export default SvgStoreRustore;